import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { MyApi } from "../MyApi";
import { Breadcrumb, Container } from "react-bootstrap";

export default function BlogDetails() {
  const { categorySlug, slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchBlogDetails = async () => {
      try {
        const res = await axios.get(
          `${MyApi.BASE_URL}Blogdetails/${encodeURIComponent(categorySlug)}/${encodeURIComponent(slug)}`,
          { headers: { Authorization: MyApi.SECRET_KEY } }
        );

        if (res.data.status) {
          setBlog(res.data.blog || {});
          setCategory(res.data.category || {});
        } else {
          setError(res.data.message || "Blog not found");
        }
      } catch (err) {
        console.error("API error:", err.response?.data || err.message);
        setError("API request failed");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogDetails();
  }, [categorySlug, slug]);

  if (loading) return <p className="text-center py-5">Loading blog...</p>;
  if (error) return <p className="text-center py-5">{error}</p>;
  if (!blog) return <p className="text-center py-5">No blog data available</p>;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  };

  return (
    <div className="blog-details">
      <div className="BreadcrumbStyle">
        <Container>
          <h1>{blog?.productname || "Blog Title"}</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            {category?.categoryurl && category?.categoryheading && (
              <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/${category.categoryurl}` }}>
                {category.categoryheading}
              </Breadcrumb.Item>
            )}
            <Breadcrumb.Item active>{blog.productname || "Blog Title"}</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>
      <div className="container py-5">
      <div className="h-80vh">     
        {blog?.created_on && <span className="blog-date">Date : {formatDate(blog.created_on)}</span>}
        {category?.categoryheading && <p>Category: <strong>{category.categoryheading}</strong></p>}
        <h4 className="mb-3">{blog?.productname || "Blog Title"}</h4>
        {blog?.image_url && <img src={blog.image_url} alt={blog.productname} className="img-fluid mb-4" />}
        {blog?.productcontent ? (
          <div dangerouslySetInnerHTML={{ __html: blog.productcontent }}></div>
        ) : <p>No content available for this blog.</p>}
         </div>
      </div>
    </div>
  );
}
